import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { getAlertsWhatsappGroup } from '@app/modules/admin/api';
import { CopyBtn } from '@mi-front/ui';
import { Box, Button, Link } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { manageAlertsMessages as messages } from './manage-alerts-messages';

/**
 * Fetches and displays the WhatsApp invite link used for alert notifications.
 */
export function ManageAlertsWaGroup() {
  const [enabled, setEnabled] = useState(false);
  const query = useQuery({
    queryKey: ['alerts-wa-group'],
    queryFn: () => getAlertsWhatsappGroup(),
    enabled,
  });

  return (
    <ContentCluster message={messages.waGroupTitle} divider={false}>
      {!query.data && (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => setEnabled(true)}
          loading={query.isLoading}
        >
          <FormattedMessage {...messages.getInviteLink} />
        </Button>
      )}
      {query.data && (
        <Box>
          <Box mb={2}>
            <Link href={query.data.groupInviteLink} target="_blank">
              {query.data.groupInviteLink}
            </Link>
          </Box>
          <CopyBtn size="small" copyValue={query.data.groupInviteLink}>
            <FormattedMessage {...messages.copyInviteLink} />
          </CopyBtn>
        </Box>
      )}
    </ContentCluster>
  );
}
